
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'neutral';
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({ children, className, variant = 'primary', isLoading = false, ...props }) => {
  const baseStyle = "px-4 py-2 rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-150 ease-in-out inline-flex items-center justify-center";
  
  let variantStyle = "";
  switch(variant) {
    case 'primary':
      variantStyle = "bg-slate-700 text-sky-400 hover:bg-slate-700 focus:ring-primary-light";
      break;
    case 'secondary':
      variantStyle = "text-sky-400 hover:bg-secondary-dark focus:ring-secondary-light";
      break;
    case 'neutral':
      variantStyle = "bg-gray-200 text-sky-400 hover:bg-gray-300 focus:ring-gray-400";
      break;
  }
  
  const disabledStyle = "disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <button
      {...props}
      disabled={props.disabled || isLoading}
      className={`${baseStyle} ${variantStyle} ${disabledStyle} ${className}`}
    >
      {isLoading && (
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button;